import { Record } from "immutable";

const CancellationRequestObjectRecord = Record({
  class: ``,
  created_by_email: ``,
  created_by_id: null,
  created_by_name: ``,
  created_on: undefined,
  id: null,
  updated_on: null,
  url_path: ``,
  status: "",
  feedback: "",
  survey: {},
});

class CancellationRequestObject extends CancellationRequestObjectRecord {
  getCancellationRequestId() {
    return this.id;
  }
}

export default CancellationRequestObject;
